import React from 'react';
import { getLayoutForLocation, FloorPlan } from '../data/layouts';

interface LocalViewProps {
  selectedMapLocation: string | null;
}

const LocalView: React.FC<LocalViewProps> = ({
  selectedMapLocation
}) => {
  // Get the layout for the selected location
  const selectedLocation = selectedMapLocation || 'Unknown';
  const layout = getLayoutForLocation(selectedLocation);
  
  // Debug logging
  console.log('LocalView Debug:', {
    selectedMapLocation,
    selectedLocation,
    layoutFound: !!layout,
    layoutType: layout?.type
  });

  return (
    <div style={{ 
      width: '100%', 
      position: 'relative', 
      overflow: 'hidden', 
      zIndex: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      {layout && (
        <div style={{
          width: layout.width * 50 + 100, // Add 50px padding on each side
          height: layout.height * 50 + 100, // Add 50px padding on each side
          position: 'relative',
          backgroundColor: '#f5f5f5',
          border: '2px solid #333',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden' // Prevent elements from extending beyond boundaries
        }}>
          <div style={{
            width: layout.width * 50,
            height: layout.height * 50,
            position: 'relative',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            overflow: 'hidden' // Prevent elements from extending beyond boundaries
          }}>
          {layout.elements.map(element => {
            const isWall = element.type === 'wall';
            const isDoor = element.type === 'door';
            const isWindow = element.type === 'window';
            const isFurniture = element.type === 'furniture';
            const isRoom = element.type === 'room';

            return (
              <div
                key={element.id}
                style={{
                  position: 'absolute',
                  left: (element.x / layout.width) * 100 + '%',
                  top: (element.y / layout.height) * 100 + '%',
                  width: (element.width / layout.width) * 100 + '%',
                  height: (element.height / layout.height) * 100 + '%',
                  backgroundColor: element.color || '#ccc',
                  border: isWall ? '2px solid #8B4513' : '1px solid #666',
                  borderRadius: isRoom ? '4px' : '0',
                  opacity: isRoom ? 0.3 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '8px',
                  color: isRoom ? '#333' : '#fff',
                  fontWeight: isRoom ? 'bold' : 'normal',
                  textAlign: 'center',
                  pointerEvents: 'none',
                  transform: 'translate(-50%, -50%)'
                }}
              >
                {element.label}
              </div>
            );
          })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocalView;
